import React, { useState } from "react";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Grid from "@mui/material/Grid";
import TabForm, { ROLES, getTabs } from "./TableTab";
import useAuth from "../../hooks/useAuth";

const TabPanel = ({ children, value, tab, ...other }) => {
  return (
    <Box
      role="tabpanel"
      hidden={value !== tab}
      id={`simple-tabpanel-${value}`}
      aria-labelledby={`simple-tab-${value}`}
      {...other}
    >
      {value === tab && children}
    </Box>
  );
};

const GridFields = ({
  name,
  tabs,
  roles = Object.keys(ROLES),
  currentTab: externalCurrentTab,
  setCurrentTab: externalSetCurrentTab,
  showTabs = true,
}) => {
  const { user } = useAuth();
  const { settings } = user.company;
  const defaultTabs = getTabs(settings);
  const tabsToRender = tabs || defaultTabs;
  const [internalCurrentTab, setInternalCurrentTab] = useState("pages");

  const currentTab = externalCurrentTab !== undefined ? externalCurrentTab : internalCurrentTab;
  const setCurrentTab = externalSetCurrentTab || setInternalCurrentTab;

  return (
    <>
      {showTabs && (
        <Grid container spacing={2}>
          <Grid container spacing={2} alignItems="center" justifyContent="space-between" size={12}>
            <Grid size={12}>
              <Box mt={2}>
                <Tabs
                  scrollButtons="auto"
                  variant="scrollable"
                  textColor="secondary"
                  value={currentTab}
                  onChange={(_event, value) => setCurrentTab(value)}
                >
                  {tabsToRender.map((tab, index) => (
                    <Tab
                      key={`tab-${index}`}
                      label={tab.label}
                      value={tab.id}
                      sx={{ textTransform: "none", fontSize: "1rem" }}
                    />
                  ))}
                </Tabs>
              </Box>
              <Divider />
            </Grid>
          </Grid>
        </Grid>
      )}

      <Box mb={showTabs ? 5 : 2}></Box>

      <Grid container spacing={1}>
        <Grid size={12}>
          {tabsToRender.map((tab, index) => (
            <TabPanel key={index} value={tab.id} tab={currentTab}>
              <TabForm name={name} tabKey={tab.id} roles={roles} features={tab.features} />
            </TabPanel>
          ))}
        </Grid>
      </Grid>
    </>
  );
};

export default GridFields;
